import { apiBaseUrl } from 'app/src/msw/membership/api/apiBaseUrl'
import { userInfoCollection } from 'app/src/msw/membership/initialSeed/userInfo'
import type { membershipApi } from 'app/src/services/welfareportal'
import { http, HttpResponse, type DefaultBodyType } from 'msw'

export const getUserInfo = http.get<object, DefaultBodyType, membershipApi.UserInfo>(apiBaseUrl + '/users/info', async () => {
  // DEFAULT -> partner image Grid. ELSE -> partner grid carousel
  // It's a mock, please dear linter
  const response: membershipApi.UserInfo | undefined = userInfoCollection.findFirst()
  console.log('getUserInfo response', response)

  return HttpResponse.json(response, { status: 200 })
})
